// extracted by mini-css-extract-plugin
export default {"menuContainer":"Menu_menuContainer__HCX01","menuContent":"Menu_menuContent__UiMJ4"};